<template>
  <div
    v-if="development"
    class="relative w-100 vh-100 overflow-hidden bg-light"
  >
    <div
      class="fixed top-0 left-0 bottom-0 w-25"
      style="z-index: 100;"
    >
      <Sidebar />
    </div>
    <div
      class="w-100 h-100"
      style="padding-right: 6vw;"
    >
      <transition
        @enter="animEnter"
        @leave="animLeave"
        mode="out-in"
        class="vh-100 flex flex-column"
      >
        <router-view
          :brand="development.brand"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/about/Sidebar'
import transitions from '../transitions.js'

export default {
  name: 'About',
  components: {
    Sidebar
  },
  computed: {
    activeTab () {
      return this.$store.state.sidebarTab
    },
    prevTab () {
      return this.$store.state.prevSidebarTab
    },
    development () {
      if (this.$store.state.content) {
        return this.$store.getters.getDevelopment('developments/' + this.$route.params.id)
      } else {
        return null
      }
    }
  },
  methods: {
    animEnter (el, done) {
      if (this.activeTab < this.prevTab) {
        transitions.fadeInUp(el, done)
      } else {
        transitions.fadeInDown(el, done)
      }
    },
    animLeave (el, done) {
      if (this.activeTab < this.prevTab) {
        transitions.fadeOutDown(el, done)
      } else {
        transitions.fadeOutUp(el, done)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('setSidebarNav', -1)
    this.$store.commit('setActiveTab', 0)
    next()
  }
}
</script>
